
import Vue from 'vue';
import moment from 'moment';
import ReturnDisplay from '@/components/generic/ReturnDisplay.vue';
import { FraudForceResult, IFraudForceResult } from '@/plugins/fraudForce';
import { Iovation } from '@/plugins/iovation';
import { EventBus } from '@/plugins/eventBus';
import { GetValue } from '@/plugins/utilities';
import { trans } from '@/i18n';
import { LogIt } from '@/plugins/webApi';

export default Vue.extend({
  data() {
    return {
      fraudResult: {} as IFraudForceResult,
      user: '',
      ffDisplay: {} as any,
      ckDisplay: {} as any,
    };
  },
  components: {
    ReturnDisplay,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
    ruleset: {
      type: String,
      required: true,
    },
    ti: {
      type: Array,
    },
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    show(n: boolean, o: boolean): void {
      if (n) {
        if ((this as any).name === 'fraudforce') {
          (this as any).sendFraudForce();
        } else {
          const bboxEl = document.querySelector('#ioBB');
          const bbox = GetValue(bboxEl || new Element(), 'value');
          const io = new Iovation({
            name: 'clearkey_check',
            blackbox: bbox,
            data: { user: (this as any).username },
          });
          (this as any).sendClearKey(io);
        }
      }
    },
  },
  computed: {
    resultColor() {
      if ((this as any).fraudResult) {
        switch (((this as any).fraudResult as FraudForceResult).result.toLowerCase()) {
          case 'a':
            return 'success';
          case 'r':
            return 'warning';
          default:
            return 'error';
        }
      } else {
        return 'success';
      }
    },
    ckResultColor() {
      if (((this as any).fraudResult as any).body) {
        switch (((this as any).fraudResult as any).body.matchStatus.toLowerCase()) {
          case 'no_match':
            return 'error';
          case 'match':
            return 'success';
        }
      }
    },
  },
  methods: {
    sendFraudForce(): void {
      (this as any).fraudResult = {} as IFraudForceResult;
      EventBus.$emit('message', { text: 'Sending Device Risk Call' });
      const bboxEl = document.querySelector('#ioBB');
      const io = new Iovation({
        name: (this as any).name,
        blackbox: GetValue(bboxEl || new Element(), 'value'),
        data: {
          user: (this as any).username,
          ti: (this as any).ti,
          type: (this as any).ruleset,
        },
      });
      io.Send()
        .then((result) => {
          EventBus.$emit('message', { text: 'Device Risk is back!' });
          if (!result.data.code) {
            (this as any).fraudResult = result.data;
            (this as any).ffDisplay = new FraudForceResult((this as any).fraudResult as IFraudForceResult).format('rgba(128,128,128,0.2)');
            EventBus.$emit('raw', { text: JSON.stringify(result.data) });
            LogIt(`(Components/FraudForce.vue)->sendFraudForce() iovation FraudForce has been invoked [IDV] [FF] ${result.data['trackingNumber']} ${result.data['id']}`, false);
          } else {
            EventBus.$emit('message', { context: 'error', text: `${trans('error')} ${result.data.message}` });
            LogIt(`(Components/FraudForce.vue)->sendFraudForce() [IDV] [FF] error ${result.data.message}`, true);
          }
        })
        .catch((reason) => {
          EventBus.$emit('message', { text: `${trans('error')} ${reason}`, context: 'error' });
          LogIt(`(Components/FraudForce.vue)->sendFraudForce() ${reason}`, true);
        });
    },
    toDate(dt: Date): string {
      return moment(dt).fromNow();
    },
    toBoolean(tf: boolean): string {
      return tf ? 'Yes' : 'No';
    },
    toResult(ch: string): string {
      switch (ch) {
        case 'A':
          return trans('iovation.fraudforce.allow').toString();
        case 'R':
          return trans('iovation.fraudforce.review').toString();
        case 'D':
          return trans('iovation.fraudforce.deny').toString();
        default:
          return trans('iovation.fraudforce.allow').toString();
      }
    },
    removeUnderScores(txt: string): string {
      return txt.replace(/_/gi, ' ');
    },
    clearKeyRegUn(isReg: boolean) {
      const bboxEl = document.querySelector('#ioBB');
      const bbox = GetValue(bboxEl || new Element(), 'value');
      let io;
      if (isReg) {
        io = new Iovation({
          name: 'clearkey_register',
          blackbox: bbox,
          data: { user: (this as any).username },
        });
      } else {
        io = new Iovation({
          name: 'clearkey_unregister',
          blackbox: bbox,
          data: { user: (this as any).username },
        });
      }
      (this as any).sendClearKey(io);
    },
    sendClearKey(io: Iovation): void {
      io.Send()
        .then((result) => {
          EventBus.$emit('message', { text: 'ClearKey has been received!' });
          (this as any).fraudResult = Object.assign((this as any).fraudResult, { clearKey: result.data });
          (this as any).ckDisplay = new FraudForceResult((this as any).fraudResult as IFraudForceResult).formatClearKey('rgba(128,128,128,0.2)');
          EventBus.$emit('raw', { text: JSON.stringify(result.data) });
        })
        .catch((reason) => {
          EventBus.$emit('message', { text: `${trans('error')} ${reason}`, context: 'error' });
          LogIt(`(Components/FraudForce.vue)->sendClearkey() ${reason}`, true);
        });
    },
  },
  mounted() {
    if ((this as any).username.length < 2 || (this as any).username === '') {
      (this as any).user = 'bradd.schick@iovation.com';
    } else {
      (this as any).user = (this as any).username;
    }
  },
});
